import { useEffect, useState } from "react";
import { getSupportAlerts } from "util/ApiCalls";

// Fetches the support-alert data for a customer and buckets supportStaffWithAlerts into the
// tab datasets: customer staff (no handheld_config), terminal (with handheld_config), and admin
// (is_customer=false). `refresh` is handed to the tabs so they can refetch after a mutation.
export const useSupportAlerts = (selectedCustomer) => {
  const [staffAlerts, setStaffAlerts] = useState([]);
  const [terminalAlerts, setTerminalAlerts] = useState([]);
  const [adminStaffAlerts, setAdminStaffAlerts] = useState([]);
  const [fraudContacts, setFraudContacts] = useState([]);
  const [possibleStations, setPossibleStations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = async () => {
    setIsLoading(true);
    const data = await getSupportAlerts(selectedCustomer);
    if (!data) {
      setIsLoading(false);
      return;
    }
    setStaffAlerts(data.supportStaffWithAlerts.filter((alert) => alert.is_customer && !alert.handheld_config));
    setTerminalAlerts(data.supportStaffWithAlerts.filter((alert) => alert.is_customer && alert.handheld_config));
    setAdminStaffAlerts(data.supportStaffWithAlerts.filter((alert) => !alert.is_customer));
    setFraudContacts(data.fraud_contacts);
    setPossibleStations(data.possibleStations);
    setIsLoading(false);
  };

  useEffect(() => {
    refresh();
  }, [selectedCustomer]); // eslint-disable-line react-hooks/exhaustive-deps

  return { staffAlerts, terminalAlerts, adminStaffAlerts, fraudContacts, possibleStations, isLoading, refresh };
};
